export default __webpack_public_path__ + "static/mvp-development-company-peerbits-e89f5b623a6c4abe1069753b01f687b2.png";